import { Spinner, useAuth } from '@/dc-shared-web/src'
import Header from '@/app/core/components/Header'
import HeaderWithHelpCenter from '@/app/core/components/HeaderWithHelpCenter'
import { useRollbarPerson } from '@rollbar/react'
import { useEnvContext } from 'next-runtime-env'

export default function MainContent({
  children,
}: {
  children: React.ReactNode
}) {
  const { NEXT_PUBLIC_PYLON_ENABLED } = useEnvContext()
  const { user, isAuthenticating } = useAuth()

  const showUseHelpCenter = !isAuthenticating && NEXT_PUBLIC_PYLON_ENABLED

  useRollbarPerson({
    id: user.uuid,
    email: user.email,
  })

  /**
   * If a user hasn't loaded yet, show the spinner until they have, if a user hasn't
   * authenticated yet, then the other logout logic will kick them to the login page
   */
  return (
    <>
      {isAuthenticating ? (
        <div className='tw-flex tw-items-center tw-justify-center tw-h-screen tw-w-screen'>
          <Spinner className='tw-h-12 tw-w-12' />
        </div>
      ) : (
        <>
          {showUseHelpCenter ? <HeaderWithHelpCenter /> : <Header />}
          <div className='tw-flex tw-h-screen-minus-header'>{children}</div>
        </>
      )}
    </>
  )
}
